import { RegExStrings } from '../lib/util/DataHelpers';

const useIsIosDevice = () => {
  const { userAgent } = navigator;
  return userAgent.match(RegExStrings.iPhone) || userAgent.match(RegExStrings.iPad);
};

export default useIsIosDevice;
